module.exports = __webpack_public_path__ + "static/guessn_logo-3f3ac75551ce386742fb1013c0dfe0b3.png";